import {currentUrlToParams} from './index.js'
import {Toast} from 'vant'
import Config from '@/config/app.js'
import {pageConfig} from '@/config/clientPageConfig.js'
import {getNurseFuelVar} from '@/utils/nurseFuelVar.js'


const currentPageParams = currentUrlToParams()

export function validateAndInitVar() {
    window.PAGE_PARAMS = currentPageParams;
    //let nurseFuelVar = getNurseFuelVar();
    // 为方便本地调试，先写死userId, 连接客户端不能写死
    //window.PAGE_PARAMS['userId'] = nurseFuelVar.id;
    //window.PAGE_PARAMS['userId'] = 1;
    let noRequiredParams = false;
    let errorMsg = '';
    if(pageConfig.requiredParams && Object.keys(pageConfig.requiredParams).length != 0){
        let requiredParams = pageConfig.requiredParams;
        errorMsg = 'Url缺少参数:';
        for (let key in requiredParams){
            if(!PAGE_PARAMS.hasOwnProperty(key)){
                errorMsg += `[${key}${requiredParams[key]}]`;
                noRequiredParams = true
            }
        }
    }
    if(pageConfig.localStorage && Object.keys(pageConfig.localStorage).length != 0 && !noRequiredParams){
        let requiredParams = pageConfig.localStorage;
        errorMsg = 'localStorage缺少数据:';

        for (let key in requiredParams){
            if(!localStorage.getItem(key)){
                errorMsg += `[${key}${requiredParams[key]}]`;
                noRequiredParams = true
            }
        }
    }
    if(pageConfig.sessionStorage && Object.keys(pageConfig.sessionStorage).length != 0 && !noRequiredParams){
        let requiredParams = pageConfig.sessionStorage;
        errorMsg = 'sessionStorage缺少数据:';

        for (let key in requiredParams){
            if(!sessionStorage.getItem(key)){
                errorMsg += `[${key}${requiredParams[key]}]`;
                noRequiredParams = true
            }
        }
    }
    if(noRequiredParams){
        alert(errorMsg);
        throw new Error(errorMsg);
        return false
    }

    return true
}


